import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import CloseIcon from '@mui/icons-material/MenuOpen';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import Collapse from '@mui/material/Collapse';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ListItem } from '@mui/material';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import { useLocation } from 'react-router-dom';
import SyncIcon from '@mui/icons-material/Sync';
import { NAV_DRAWER_WIDTH } from '../../configs/Constants';
import RoutePaths from '../../configs/Routes';
import NavItem from './NavItem';

const SideBar = ({ open, onClose }) => {
  const { pathname } = useLocation();
  const [affiliatesOpen, setAffiliatesOpen] = React.useState(false);

  const handleAffiliatesClick = () => {
    setAffiliatesOpen(!affiliatesOpen);
  };

  return (
    <Drawer
      open={open}
      variant="persistent"
      anchor="left"
      onClose={onClose}
      sx={{
        width: NAV_DRAWER_WIDTH,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          minWidth: NAV_DRAWER_WIDTH,
          bgcolor: 'background.paper',
        },
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          height: 80,
          flexShrink: 0,
          px: 0.5,
          position: 'sticky',
          top: 0,
          zIndex: 'appBar',
          backgroundColor: 'inherit',
          backgroundImage: 'inherit',
        }}
      >
        <IconButton aria-label="Close navigation drawer" onClick={onClose} size="large">
          <CloseIcon />
        </IconButton>
      </Stack>

      <nav>
        <List disablePadding>
          <li>
            <NavItem to={RoutePaths.HOME}>
              <ListItemIcon>
                <AssessmentOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </NavItem>
          </li>
          <li>
            <ListItem button selected={affiliatesOpen} onClick={handleAffiliatesClick}>
              <ListItemIcon>
                <PeopleOutlineIcon />
              </ListItemIcon>
              <ListItemText primary="Affiliates" />
              {affiliatesOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
            <Collapse in={affiliatesOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <li>
                  <NavItem sx={{ pl: 3 }} to={RoutePaths.AFFILIATES}>
                    <ListItemIcon>
                      <RecentActorsIcon />
                    </ListItemIcon>
                    <ListItemText primary="All Affiliates" />
                  </NavItem>
                </li>
                <li>
                  <NavItem sx={{ pl: 3 }} to={RoutePaths.AFFILIATES_PENDING_APPROVAL}>
                    <ListItemIcon>
                      <PendingActionsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Pending Approvals" />
                  </NavItem>
                </li>
                <li>
                  <NavItem sx={{ pl: 3 }} to={RoutePaths.APPROVED_AFFILIATES}>
                    <ListItemIcon>
                      <CheckBoxIcon />
                    </ListItemIcon>
                    <ListItemText primary="Approved Approvals" />
                  </NavItem>
                </li>
              </List>
            </Collapse>
          </li>
          <li>
            <NavItem to={RoutePaths.BLOGS} button selected={pathname.includes('blogs')}>
              <ListItemIcon>
                <LibraryBooksIcon />
              </ListItemIcon>
              <ListItemText primary="Blogs" />
            </NavItem>
          </li>
          <li>
            <NavItem to={RoutePaths.INVENTORYSYNC}>
              <ListItemIcon>
                <SyncIcon />
              </ListItemIcon>
              <ListItemText primary="Sync Inventory" />
            </NavItem>
          </li>
          <Divider variant="middle" sx={{ my: 1 }} />
          <li>
            <NavItem to={RoutePaths.LOGOUT}>
              <ListItemIcon>
                <ExitToAppOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </NavItem>
          </li>
        </List>
      </nav>
    </Drawer>
  );
};

SideBar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SideBar;
